import p from "./_listCacheClear.js";
import a from "./_listCacheDelete.js";
import i from "./_listCacheGet.js";
import h from "./_listCacheHas.js";
import s from "./_listCacheSet.js";
function t(e) {
  var o = -1, l = e == null ? 0 : e.length;
  for (this.clear(); ++o < l; ) {
    var r = e[o];
    this.set(r[0], r[1]);
  }
}
t.prototype.clear = p;
t.prototype.delete = a;
t.prototype.get = i;
t.prototype.has = h;
t.prototype.set = s;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_ListCache.js
// module id = 308
// module chunks = 67